import { TOKEN, USER_INFO } from "@/core/const/global-const";
import { LocalStorage } from "@/util";
import { Message } from "element-ui";
import StompClient from "./stomp-client";

export class SocketService {
  static getConnection() {
    return new Promise((resolve, reject) => {
      if (SocketService.client && SocketService.client.active) {
        resolve(SocketService.client);
      } else {
        const token = LocalStorage.get(TOKEN);
        if (!token) {
          reject(new Error("未检测到登录令牌，请先登录"));
          return;
        }
        const user = LocalStorage.get(USER_INFO);
        // name 放在查询串里，SockJS 各次 HTTP 传输会带上，Servlet Filter 可用 getParameter("name") 读取；
        // STOMP 的 connectHeaders 在 CONNECT 帧里，Filter 阶段拿不到。
        const hintName = encodeURIComponent(user?.name || user?.username || "");
        const url = `/notification?${TOKEN}=${token}&name=${hintName}`;
        const stompClient = new StompClient(url, { name: user?.id });
        SocketService.client = stompClient;
        stompClient.connect(
          () => {
            Message.success("推送消息连接成功");
            resolve(stompClient);
          },
          (error) => {
            console.error("Error connecting to STOMP:", error);
            Message.error("推送消息连接失败");
            reject(error);
          }
        );
      }
    });
  }

  static async subscribeTopic(topic, callback) {
    const stompClient = await SocketService.getConnection();
    // eslint-disable-next-line no-unused-vars
    const subscription = stompClient.subscribe(topic, (message) => {
      // console.log("Received message:", JSON.parse(message.body));
      callback(JSON.parse(message.body));
    });

    // Use `subscription` to unsubscribe if necessary
  }

  static disconnect() {
    if (SocketService.client) {
      SocketService.client.disconnect();
    }
  }
}
